export { default } from './FormControl';
export { default as useFormControl } from './useFormControl';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/FormControl/index.js
// module id = 248
// module chunks = 0